import { render, staticRenderFns } from "./CvDetailDialog.vue?vue&type=template&id=e224c812&scoped=true"
import script from "./CvDetailDialog.vue?vue&type=script&lang=js"
export * from "./CvDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./CvDetailDialog.vue?vue&type=style&index=0&id=e224c812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e224c812",
  null
  
)

export default component.exports